import { Component, Input } from '@angular/core';
import {
  ContentMetricRow,
  ProfContentPerformanceRow,
  ProfMediaEngagementRow,
  MediaTypePerf
} from '../../models/analytics.types';
import { PAGE_SIZE } from '../../models/period-trends.const';

@Component({
  selector: 'tangram-pa-content-performance-tab',
  templateUrl: './content-performance-tab.component.html',
  styleUrls: ['./content-performance-tab.component.scss']
})
export class ContentPerformanceTabComponent {
  @Input() contentMetrics: ContentMetricRow[] = [];
  @Input() contentPerfRows: ProfContentPerformanceRow[] = [];
  @Input() mediaEngagementRows: ProfMediaEngagementRow[] = [];
  @Input() mediaTypePerformance: MediaTypePerf[] = [];

  readonly PAGE_SIZE = PAGE_SIZE;
  contentMetricsPage = 1;
  mediaEngagementPage = 1;
  mediaTypePage = 1;

  contentSortField: keyof ContentMetricRow = 'views';
  contentSortDir: 'asc' | 'desc' = 'desc';

  get sortedContentMetrics(): ContentMetricRow[] {
    const field = this.contentSortField;
    const dir = this.contentSortDir === 'asc' ? 1 : -1;
    return [...this.contentMetrics].sort((a, b) => {
      const av = a[field] as any;
      const bv = b[field] as any;
      return (typeof av === 'number' && typeof bv === 'number')
        ? (av - bv) * dir
        : String(av).localeCompare(String(bv)) * dir;
    });
  }

  get pagedContentMetrics(): ContentMetricRow[] {
    return this.sortedContentMetrics.slice(
      (this.contentMetricsPage - 1) * this.PAGE_SIZE,
      this.contentMetricsPage * this.PAGE_SIZE
    );
  }

  get pagedMediaEngagement(): ProfMediaEngagementRow[] {
    return this.mediaEngagementRows.slice(
      (this.mediaEngagementPage - 1) * this.PAGE_SIZE,
      this.mediaEngagementPage * this.PAGE_SIZE
    );
  }

  get pagedMediaType(): MediaTypePerf[] {
    return this.mediaTypePerformance.slice(
      (this.mediaTypePage - 1) * this.PAGE_SIZE,
      this.mediaTypePage * this.PAGE_SIZE
    );
  }

  get topPerformingContent(): ProfContentPerformanceRow[] {
    return this.contentPerfRows.filter(r => r.status === 'top').slice(0, 5);
  }

  get lowPerformingContent(): ProfContentPerformanceRow[] {
    return this.contentPerfRows.filter(r => r.status === 'low').slice(0, 5);
  }

  sortContentBy(field: keyof ContentMetricRow): void {
    if (this.contentSortField === field) {
      this.contentSortDir = this.contentSortDir === 'asc' ? 'desc' : 'asc';
    } else {
      this.contentSortField = field;
      this.contentSortDir = 'desc';
    }
    this.contentMetricsPage = 1;
  }

  sortIcon(field: keyof ContentMetricRow): string {
    if (this.contentSortField !== field) { return '↕'; }
    return this.contentSortDir === 'asc' ? '↑' : '↓';
  }
}
